import { render, staticRenderFns } from "./ProductionBrain.vue?vue&type=template&id=7f66fbb1&scoped=true"
import script from "./ProductionBrain.vue?vue&type=script&lang=js"
export * from "./ProductionBrain.vue?vue&type=script&lang=js"
import style0 from "./ProductionBrain.vue?vue&type=style&index=0&id=7f66fbb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66fbb1",
  null
  
)

export default component.exports